export const STORAGE_KEY = 'lavascend.tokens';
export const STARTING_TOKENS = 1;

function loadCount(): number {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (raw === null) {
    localStorage.setItem(STORAGE_KEY, String(STARTING_TOKENS));
    return STARTING_TOKENS;
  }
  const n = Number.parseInt(raw, 10);
  if (!Number.isFinite(n) || n < 0) {
    localStorage.setItem(STORAGE_KEY, String(STARTING_TOKENS));
    return STARTING_TOKENS;
  }
  return n;
}

export class TokenWallet {
  private _count: number;

  constructor() {
    this._count = loadCount();
  }

  get count(): number { return this._count; }

  spend(): boolean {
    if (this._count <= 0) return false;
    this._count -= 1;
    localStorage.setItem(STORAGE_KEY, String(this._count));
    return true;
  }

  grant(n: number): void {
    if (!Number.isFinite(n) || n <= 0) return;
    this._count += Math.floor(n);
    localStorage.setItem(STORAGE_KEY, String(this._count));
  }
}
